import './PeriodSelector.css';

export type ChartPeriod = string;

export interface PeriodOption {
  label: string;
  value: ChartPeriod;
}

export interface PeriodSelectorProps {
  options: PeriodOption[];
  value: ChartPeriod;
  onChange: (period: ChartPeriod) => void;
}

const PeriodSelector = ({
  options,
  value,
  onChange,
}: PeriodSelectorProps): JSX.Element => {
  return (
    <div className="period-selector" role="tablist">
      {options.map((opt) => (
        <button
          key={opt.value}
          type="button"
          role="tab"
          aria-selected={value === opt.value}
          className={`period-selector__item${
            value === opt.value ? ' active' : ''
          }`}
          onClick={() => onChange(opt.value)}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
};

export default PeriodSelector;
